
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
import { MstOrderVO, RelOrderProductVO, OrderMetaVO, MstDepartureVO, MstCommonCodeVO } from "@/views/biz/order/vo/order.vo";
import { MstMemDeliveryVO, SlvMemberIdentityVO } from "@/views/biz/mypage/vo/mypage.vo";
import { MstMemberVO, MstMemGradeVO } from "@/views/biz/join/vo/join.vo";
import DeliveryAddressChoicePop from "./DeliveryAddressChoicePop.vue";
import { DateTime } from "luxon";
import CommonUtils from "../../../common-utils";
import Constants from "@/constants";
import { MstCouponVO } from "../coupon/vo/coupon.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import AdLogs from "@/ad-logs";
import { FacebookVO, ContentsVO } from '@/vo/facebook.vo';

@Component({
  components: { DeliveryAddressChoicePop, CommonModalDialog },
})
export default class OrderPayment extends Vue {
  @Prop() orderCd;
  @Prop() refreshProducts; // 상품 쿠폰 변경 등에 쓰임
  deliveryType: "01" | "02" = "01"; // 배송 방식 01: 택배, 02: 픽업

  order = {} as MstOrderVO;
  products = [] as Array<RelOrderProductVO>;
  defaultAddress = {} as MstMemDeliveryVO;
  defaultAuth = {} as SlvMemberIdentityVO;
  member = {} as MstMemberVO;
  memGrade = {} as MstMemGradeVO;
  orderMeta = {} as OrderMetaVO;
  departure = {} as MstDepartureVO;
  orderCoupons = [] as Array<MstCouponVO>;

  currentOrderCoupon = {} as MstCouponVO;
  commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>; // 공통코드 (배송요청사항))

  // 회원 포인트 팝업
  showMemberPointPop = false;
  memberPointInput = 0;

  // 픽업 팝업
  showPickupChoicePop = false;

  // 배송지 팝업
  showAddressChoicePop = false;

  // 실명 인증 팝업
  showAuthPop = false;

  // 장바구니 쿠폰
  showOrderCoupons = true;

  // 중복 클릭 방지
  putOrderKey = 0;

  //배송요청사항 직접입력,시향지
  showMemo = false;
  orderMemo = { code: "", codeNm: "" };

  pickDateInput = "";
  @Watch("pickDateInput")
  onPickDateChange(): void {
    let pickDate = DateTime.fromISO(this.pickDateInput);
    if (pickDate.hour == 0) {
      // 날짜 변경 시 hour 가 0으로 세팅됨
      pickDate = pickDate.plus({ hours: this.orderMeta.defaultPickStartTime }); // 기본 픽업 시작 시간으로 변경
      this.pickDateInput = pickDate.toISO();
      return;
    }
    this.order.pickDate = pickDate.toFormat("yyyy-MM-dd HH:mm:ss");
  }

  // 장바구니 쿠폰 바뀌면 포인트 리셋함
  @Watch("currentOrderCoupon")
  onCouponChange(): void {
    this.order.orderUsePoint = 0;
    this.memberPointInput = 0;
  }

  // computed

  get minPickDate(): string {
    // 최소 픽업 일 (홍콩배송: 익일, 일반배송: 도착일의 익일)
    let result;
    if (this.isComplexOrder == false && this.products.length && this.products[0].productType == "02") {
      // 홍콩 상품 주문이면
      result = DateTime.fromJSDate(new Date());
    } else {
      result = DateTime.fromISO(this.departure.arrivalTime);
    }

    result = result.set({
      hour: this.orderMeta.defaultPickStartTime,
      minute: 0,
      second: 0,
    });
    return result.plus({ days: 1 }).toISO();
  }
  get minPickTime(): string {
    // 최소 픽업 시간
    let result = DateTime.fromISO(this.pickDateInput);
    result = result.set({
      hour: this.orderMeta.defaultPickStartTime,
      minute: 0,
      second: 0,
    });
    return result.toISO();
  }
  get maxPickTime(): string {
    // 최대 픽업 시간
    let result = DateTime.fromISO(this.pickDateInput);
    result = result.set({
      hour: this.orderMeta.defaultPickEndTime,
      minute: 0,
      second: 0,
    });
    return result.toISO();
  }

  // 중국 배송임?(홍콩(71), 대만(81), 마카오(82) 제외, profile=kr 제외 )
  get isChinaDelivery(): boolean {
    let result = true;

    // SYSTEM locale 이 cn 아니면 false
    if ((process.env.VUE_APP_SYSTEM_LOCALE == "cn") == false) {
      return false;
    }
    // 홍콩주소로만 체크하면 되는데 굳이 픽업이면 빼달라고 함
    if (this.order.deliveryType == "02") {
      return false;
    }

    if (!this.order.addrSerialNo) {
      return result;
    }

    // 왠지 또 바뀔것같아서 남겨둠
    // ['777777771','777777781','777777782'].forEach(startSerialNo => {
    ["777"].forEach((startSerialNo) => {
      if (this.order.addrSerialNo.startsWith(startSerialNo)) {
        result = false;
        return;
      }
    });
    return result;
  }

  // 팝업 배경
  get dimmed(): boolean {
    return this.showMemberPointPop;
  }
  set dimmed(dimmed: boolean) {
    this.showMemberPointPop = false;
  }

  get showAddressPop(): boolean {
    return this.showAddressChoicePop || this.showPickupChoicePop;
  }
  // 픽업, 배송지 팝업
  set showAddressPop(show: boolean) {
    this.showAddressChoicePop = false;
    this.showPickupChoicePop = false;

    if (show) {
      switch (this.order.deliveryType) {
        case "01":
          this.showAddressChoicePop = true;
          break;
        case "02":
          this.showPickupChoicePop = true;
          break;
      }
    }
  }

  // 소비자가 합계
  get orgPriceSum(): number {
    let result = 0;
    this.products.forEach((product) => {
      result += product.orgPrice * product.orderCount;
    });
    return result;
  }
  // 판매가 합계
  get salePriceSum(): number {
    let result = 0;
    this.products.forEach((product) => {
      result += product.salePrice * product.orderCount;
    });
    return result;
  }
  // 주문액 합계
  get orderPrice(): number {
    let result = 0;
    this.products.forEach((product) => {
      result += product.productPaymentPrice;
    });
    return Number(result.toFixed(2));
  }
  // 상품 쿠폰 할인가합
  get productCouponDiscountPriceSum() {
    let result = 0;
    this.products.forEach((product) => {
      result += product.couponDiscountPrice;
    });
    return result;
  }
  // 세금 합계
  get hsPriceSum(): number {
    if (this.order.deliveryType == "02" || this.isChinaDelivery == false) {
      // 중국 배송 아니면 세금 0
      return 0;
    }
    let result = 0;
    this.products.forEach((product) => {
      result += (product.productPaymentPrice * product.hsRate) / 100;
    });
    return result;
  }
  // 상품 할인액
  get productDscPrice(): number {
    return this.orgPriceSum - this.salePriceSum;
  }
  // 등급 할인액
  get gradeDscPrice(): number {
    let result = 0;
    this.products.forEach((product) => {
      result += product.gradeDiscountPrice * product.orderCount;
    });
    return result;
  }

  // 장바구니 쿠폰 할인액
  get orderCouponDiscountPrice(): number {
    return this.currentOrderCoupon.actualDiscountAmount || 0;
  }

  // 쿠폰할인액합
  get couponDscPriceSum(): number {
    return this.productCouponDiscountPriceSum + this.orderCouponDiscountPrice;
  }
  // 주문금액
  get orderTotalPrice(): number {
    return this.orderPrice + this.deliveryFee + this.hsPriceSum - this.order.paymentDscPrice - this.orderCouponDiscountPrice;
  }
  // 결제금액
  get paymentTotalPrice(): number {
    return this.orderTotalPrice - this.order.orderUsePoint;
  }

  // 배송비
  get deliveryFee(): number {
    if (this.order.deliveryType == "02") {
      return 0; // 02 픽업이면 무료배송이란다
    }

    let result = 0;

    const fee = this.orderMeta.deliveryFee; // 배송비
    const freeDeliveryStandard = this.orderMeta.freeDeliveryStandard; // 무료 배송 기준

    let directProductSum = 0;
    let hkProductSum = 0;

    this.products.forEach((product) => {
      let countedSalePrice = product.salePrice * product.orderCount;

      // 쿠폰 할인액 적용
      if (product.couponDiscountPrice) {
        countedSalePrice = countedSalePrice - product.couponDiscountPrice;
      }

      if (product.productType == "01") {
        // 일반 상품
        directProductSum += countedSalePrice;
      } else {
        // 홍콩 상품
        hkProductSum += countedSalePrice;
      }
    });

    // 장바구니 쿠폰이 적용되었으면
    if (this.orderCouponDiscountPrice) {
      // 장바구니 쿠폰을 억지로 각 일반, 홍콩배송 비율대로 적용함(쿠폰할인된 결제금액 > 무료배송 이면 유료배송됨 ㅋ)
      if (directProductSum) {
        directProductSum = directProductSum - this.orderCouponDiscountPrice * directProductSum / (hkProductSum || directProductSum);
      }
      if(hkProductSum) {
        hkProductSum = hkProductSum - this.orderCouponDiscountPrice * hkProductSum / (directProductSum || hkProductSum);
      }
    }

    //console.log(directProductSum, hkProductSum)

    // 안묶음배송: 일반,홍콩 상품 따로 배송비 계산함
    // 묶음배송: 일반,홍콩 합쳐서 배송비 계산함. 무료배송 기준도 마찬가지임
    switch (this.order.deliveryBundleType) {
      case "01": // 안묶음배송
        if (directProductSum && directProductSum < freeDeliveryStandard) {
          result += fee;
        }
        if (hkProductSum && hkProductSum < freeDeliveryStandard) {
          result += fee;
        }
        break;
      case "02": // 묶음배송
        if (directProductSum + hkProductSum < freeDeliveryStandard) {
          result += fee;
        }
        break;
    }

    return result;
  }

  // 최대 사용 포인트
  get maxUsePoint(): number {
    let max = this.orderPrice + this.hsPriceSum - this.order.paymentDscPrice - this.orderCouponDiscountPrice;
    if (this.isBizMember) {
      // 기업회원
      max += this.deliveryFee;
    } else {
      // 일반회원
      max *= 0.3; // 30%만 사용 가능
    }
    max = Math.floor(max);

    return this.member.memPointAmt < max ? this.member.memPointAmt : max; // 총 결제금액 보다 클 수 없음
  }

  // 복합주문임? (일반배송+홍콩주문임?)
  get isComplexOrder(): boolean {
    const productTypeSet = new Set();
    this.products.forEach((product) => {
      productTypeSet.add(product.productType);
    });
    return productTypeSet.size > 1;
  }

  // 묶음 배송 가능?
  get canBundleDelivery(): boolean {
    // 픽업일 땐 묶음 배송 안씀
    if (this.order.deliveryType == "02") {
      return false;
    }
    return this.isComplexOrder;
  }

  // 기업회원임?
  get isBizMember(): boolean {
    return this.member.memType == "02";
  }

  // 포인트 사용 가능?
  get canUsePoint(): boolean {
    // 첫구매면 불가능
    return !this.order.firstPurchaseOrder;
  }

  // 구매 가능함?
  get canBuy(): boolean {
    if (this.paymentTotalPrice) {
      return true;
    }
    if (this.isBizMember) {
      // 기업회원 포인트 전액결제 가능
      return this.orderTotalPrice > 0 && this.orderTotalPrice == this.order.orderUsePoint;
    }

    return false;
  }

  // 주문 금액 및 수량 validate
  validatePriceAndQuantitySum(): boolean {
    // 기업 회원 && 최소구매금액 존재 && 총주문액 < 기업 회원 최소 구매 금액
    if (this.isBizMember && this.orderMeta.minOrderPriceCompany && this.orderTotalPrice < this.orderMeta.minOrderPriceCompany) {
      // 기업 회원 최소 구매 금액
      alert(this.$t("order.a0029", [this.orderMeta.minOrderPriceCompany]));
      return false;
    }

    if (this.isChinaDelivery == false) {
      // 아래 부턴 중국 배송만 해당함
      return true;
    }

    type sum = { priceSum: number; countSum: number };
    const productSumMap = new Map<string, sum>();

    // 묶음배송 여부, 상품 타입별로 그룹을 만들어서
    this.products.forEach((product) => {
      const key = this.order.deliveryBundleType == "01" ? product.productType : "00";
      const val = productSumMap.get(key) || ({ priceSum: 0, countSum: 0 } as sum);
      val.priceSum += (product.salePrice - product.gradeDiscountPrice) * product.orderCount;
      val.countSum += product.orderCount;

      productSumMap.set(key, val);
    });

    // console.log(productSumMap);

    // 뺑뺑이 돌림
    let result = true;
    productSumMap.forEach((val) => {
      if (result == false) {
        return;
      }

      if (val.priceSum && this.orderMeta.maxOrderPrice && val.priceSum > this.orderMeta.maxOrderPrice) {
        // 최대 구매 금액
        alert(this.$t("order.a0005", [this.orderMeta.maxOrderPrice]));
        result = false;
        return;
      }

      if (val.priceSum && this.orderMeta.maxQuantityPerOrder && val.countSum > this.orderMeta.maxQuantityPerOrder) {
        // 최대 구매 수량
        alert(this.$t("order.a0002", [this.orderMeta.maxQuantityPerOrder]));
        result = false;
        return;
      }
    });

    return result;
  }

  // method

  // 포인트 사용 팝업
  openMemberPointPop(): void {
    if (this.member.memPointAmt < this.orderMeta.minUseMemPoint) {
      // 회원 포인트가 최소 사용 포인트 미만이면
      this.$toast(this.$t("order.a0009")); // 포인트가 부족합니다.
      return;
    }
    this.showMemberPointPop = true;
  }

  // 배송 방식 수정되면 주소 지워져야 함(@Watch 로 걸면 created 에서도 호출됨)
  onDeliveryTypeChanged(): void {
    this.order.addr = "";
    this.order.addrDetail = "";
    this.order.addrSerialNo = "";
    this.order.branchCd = "";

    switch (this.order.deliveryType) {
      case "01":
        this.setDefaultAddress(); // 기본 배송지 설정
        break;
      case "02":
        // TODO 기본 픽업 장소 설정해야 하나?
        this.pickDateInput = this.minPickDate; // 기본 픽업 날짜 설정
        break;
    }
  }

  // 기본 배송지 세팅
  setDefaultAddress(): void {
    // 배송지 정보가 없으면 기본 배송지 세팅
    if (this.defaultAddress && !this.order.addrSerialNo && this.order.deliveryType == "01") {
      this.order.addr = this.defaultAddress.addr;
      this.order.addrDetail = this.defaultAddress.addrDetail;
      this.order.addrSerialNo = this.defaultAddress.addrSerialNo;
      this.order.postNo = this.defaultAddress.postNo;
      this.order.recvNm = this.defaultAddress.recvNm;
      this.order.hpNo = this.defaultAddress.hpNo;
    }
  }

  // 회원 포인트 적용
  setMemberPointToUse(): void {
    const minUseMemPoint = this.orderMeta.minUseMemPoint;
    if (this.memberPointInput > 0) {
      if (this.memberPointInput > this.maxUsePoint) {
        this.$toast(this.$t("order.a0025", [this.maxUsePoint]));
        return;
      }
      if (this.memberPointInput < minUseMemPoint) {
        this.$toast("1,000포인트 이상부터 사용 가능합니다.");
        return;
      }
    }

    this.order.orderUsePoint = this.memberPointInput;
    this.showMemberPointPop = false;
  }

  // 결제하기
  putOrder(): void {
    this.order.orderPrice = this.orderPrice;
    this.order.paymentTotalPrice = this.paymentTotalPrice;
    this.order.deliveryFee = this.deliveryFee;
    this.order.orderCount = this.products.length;
    this.order.memberCouponSeq = this.currentOrderCoupon.memberCouponSeq;
    this.order.couponCd = this.currentOrderCoupon.couponCd;

    // validation (입력 시 못한 것들만)
    if (!this.order.addr) {
      switch (this.order.deliveryType) {
        case "01":
          alert(this.$t("order.a0011")); // 배송지를 입력하여 주세요.
          this.putOrderKey++;
          return;
        case "02":
          alert(this.$t("order.a0012")); // 픽업 장소를 선택하여 주세요.
          this.putOrderKey++;
          return;
      }
    }
    if (!this.order.recvNm) {
      alert(this.$t("order.a0013")); // 수령인을 입력하여 주세요.
      this.putOrderKey++;
      return;
    }
    if (!this.order.hpNo) {
      alert(this.$t("order.a0014")); // 휴대폰 번호를 입력하여 주세요.
      this.putOrderKey++;
      return;
    }

    if (this.isChinaDelivery && this.order.recvNm != this.order.authNm) {
      alert(this.$t("order.a0010")); // 중국 배송 시 수령인은 실명 인증 정보와 같아야 합니다.
      this.putOrderKey++;
      return;
    }

    if (CommonUtils.isSystemLocale("ko") && !this.order.persEcm) {
      alert(this.$t("member-info.a0023")); // 개인통관고유부호를 입력해 주세요.
      this.putOrderKey++;
      return;
    }

    if (this.isBizMember && this.isChinaDelivery) {
      alert(this.$t("order.a0030")); // 기업 회원은 중국으로 배송할 수 없습니다.
      this.putOrderKey++;
      return;
    }

    if (this.validatePriceAndQuantitySum() == false) {
      // 최대구매수량,최대구매금액 체크
      this.putOrderKey++;
      return;
    }
    
     // 페이스북 픽셀 결제시작 추가 태그
    AdLogs.sendMetaPixelEventLogs('InitiateCheckout', this.fbPixelParams(this.order));

    axios
      .put("/order", this.order)
      .then(() => {
        if (this.isBizMember && this.paymentTotalPrice == 0 && this.canBuy) {
          // 기업회원이면서 포인트 전액 결제면
          this.$router.push({ name: "PaymentComplete", params: { orderCd: this.orderCd } });
        }
        axios.post("/order/payment-url", this.order).then((r) => {
          if (!this.$isMobile) {
            window.open(r.data, "_blank", "width=762, height=800"); // PC웹
          } else {
            location.href = r.data; // 모바일
          }
        });
      })
      .finally(() => {
        this.putOrderKey++;
      });
  }

  init() {
    axios.get("/order/" + this.orderCd).then((r) => {
      this.order = r.data.order;

      if (this.order.paymentDate) {
        // 완료된 주문이면
        alert(this.$t("order.a0008"));
        this.$router.push({ name: "Main" });
      }

      this.products = r.data.products;
      this.defaultAddress = r.data.defaultAddress;
      this.member = r.data.member;
      this.memGrade = r.data.memGrade;
      this.defaultAuth = r.data.defaultAuth;
      this.orderMeta = r.data.orderMeta;
      this.departure = r.data.departure;
      this.orderCoupons = r.data.orderCoupons;
      this.commonCodes = r.data.orderMemo;

      if (!this.departure) {
        alert(this.$t("order.a0023")); // 인도일 없음
        this.$router.push({ name: "Main" });
      }

      // 기본 배송지 세팅
      this.setDefaultAddress();

      // 수령인 정보에 기본 회원 정보 세팅
      if (this.defaultAddress) {
        this.order.recvNm || (this.order.recvNm = this.defaultAddress.recvNm);
        this.order.hpNo || (this.order.hpNo = this.defaultAddress.hpNo);
        this.order.persEcm || (this.order.persEcm = this.defaultAddress.persEcm);
      }

      // 실명 인증 정보 없으면 기본 실명 인증 정보 세팅
      if (CommonUtils.isSystemLocale("cn") && this.defaultAuth && !this.order.memIdentityCd) {
        this.order.authNm = this.defaultAuth.memNm;
        this.order.idCardNum = this.defaultAuth.idCardNum;
        this.order.memIdentityCd = this.defaultAuth.idx;
      }

      // 장바구니 최대 쿠폰 혜택 세팅
      if(this.orderCoupons.length > 0){
        const findHighestCartCoupon = this.orderCoupons.find( val => val.couponType == '01')
        this.currentOrderCoupon = findHighestCartCoupon as MstCouponVO
      }

      if (CommonUtils.isSystemLocale("ko")) {
        // 신용카드
        this.order.paymentType = "11";
        //실명인증,개인통관고유부호 체크 ,배송지 등록 권유
        if (this.checkMemberInfo() && !this.defaultAddress && confirm("등록된 배송지가 없습니다. 등록하시겠습니까?")) {
          this.showAddressPop = true;
          return;
        }
      }


    });
  }

  //실명인증 체크
  checkMemberInfo(): boolean {
    if (CommonUtils.isSystemLocale("ko") == false) {
      // 국내 리전 말곤 필요 없음
      return true;
    }
    if (this.member.memPh) {
      return true;
    }
    if (confirm("실명인증 후 진행가능합니다. 진행하시겠습니까?")) {
      this.goRealNameAuth();
    }
    return false;
  }

  //본인인증
  goRealNameAuth(): void {
    CommonUtils.putLocalStorageObject(Constants.ORDER_PAYMENT_CD, this.orderCd);

    // PC면 새창
    if (this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, "RealNameForm")}?nextRouteName=MemberInfo`, "_blank", "width=762, height=800");
      return;
    }

    this.$router.push({ name: "RealNameForm", params: { nextRouteName: "MemberInfo" } });
  }

  activated() {
    if (this.refreshProducts) {
      // 상품쿠폰 적용
      axios.get(`/order/products/${this.orderCd}`).then((r) => {
        this.products = r.data.products;
        this.orderCoupons = r.data.orderCoupons;
        this.currentOrderCoupon = {} as MstCouponVO;
        this.showOrderCoupons = true;
        this.onCouponChange();
      });
    }
  }

  //배소요청사항 변경
  orderMemoChange(memo: any): void {
    if (memo.code == "041005" || memo.code == "041006") {
      this.showMemo = true;
      this.order.memo = "";
    } else {
      this.showMemo = false;
      this.order.memo = memo.codeNm;
    }
  }

  // init
  created() {
    this.init();
  }

  beforeCreate() {
    // pc웹 결제취소
    if (window.opener) {
      window.close();
    }
  }

  fbPixelParams(data: object): object {
    type order = {
      orderCd: number;
      paymentTotalPrice: number;
    }
    const { orderCd, paymentTotalPrice } = data as order;
    const contents = [] as Array<ContentsVO>;
    this.products.forEach((item) => {
      const obj = {} as ContentsVO;
      obj.id = item.productCd.toString();
      obj.quantity = item.orderCount;
      contents.push(obj);
    });
    return {
      contents,
      content_ids: orderCd,
      currency: 'KWD', 
      num_items: this.products.length, 
      value: paymentTotalPrice
    } as FacebookVO
  }

}
